export default __webpack_public_path__ + "static/media/block-icon.bb9a27d5.svg";